import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoConfiguracionClienteEditarComponent {
  constructor($filter, $q, FanProyectoConfiguracionClienteService, ClientesCatalogo, ClienteDireccionesCatalogo) {
    this.$q = $q
    this.FanProyectoConfiguracionClienteService = FanProyectoConfiguracionClienteService
    this.ClientesCatalogo = ClientesCatalogo
    this.ClienteDireccionesCatalogo = ClienteDireccionesCatalogo
    this.orderBy = $filter('orderBy')
    this.idProyecto = undefined
    this.onChange = undefined
    this.onClose = undefined
  }

  $onInit() {
    this.promise = this.FanProyectoConfiguracionClienteService.get(this.idProyecto)
      .then((response) => {
        this.data = response.data

        return this.$q.all([
          this.obtenerClientes(),
          this.obtenerDirecciones(),
        ])
      })
  }

  aceptar(modificado) {
    if (!modificado) {
      this.cerrar()

      return
    }

    this.actualizando = true

    return this.FanProyectoConfiguracionClienteService.put(this.idProyecto, this.data)
      .then((response) => {
        angular.extend(this.data, response.data)

        this.onChange({$event: {data: this.data}})

        this.cerrar()
      })
      .finally(() => (this.actualizando = false))
  }

  cerrar() {
    this.onClose()
  }

  obtenerClientes() {
    if (this.data && this.data.id) {
      this.clientes = null

      return this.ClientesCatalogo.get(this.data.id)
        .then((response) => (this.clientes = this.orderBy(response.data, 'descripcion')))
    }
  }

  obtenerDirecciones() {
    if (this.data && this.data.id) {
      this.direcciones = null

      return this.ClienteDireccionesCatalogo.get(this.data.id)
        .then((response) => (this.direcciones = this.orderBy(response.data, 'descripcion')))
    }
  }

  seleccionarCliente() {
    this.data.direccion = null

    this.obtenerDirecciones()
  }
}

module.component('fanProyectoConfigClienteEditar', {
  controller: FanProyectoConfiguracionClienteEditarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    onChange: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/configuracion/cliente/editar/component.js